var map = {
	"./br/earth.png": 96679,
	"./en/earth.png": 8694,
	"./fr/earth.png": 63539,
	"./ge/earth.png": 12591,
	"./la/earth.png": 87350,
	"./tw/earth.png": 84784,
	"./zh/earth.png": 15701
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42144;